console.log('fluid sim based on: https://mofu-dev.com/en/blog/stable-fluids/')

import { App } from './components/App'

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => new App()) : new App()
